"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultGasOverrides = void 0;
// https://docs.immutable.com/docs/zkEVM/architecture/gas-config
exports.defaultGasOverrides = {
    maxPriorityFeePerGas: 10e9,
    maxFeePerGas: 15e9,
    gasLimit: 200000, // Expected when setting the above properties
};
